import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SessionGenerator from './SessionGenerator';
import QRGenerator from './QRGenerator';

function App() {
  return (
    <Routes>
      <Route path="/" element={<SessionGenerator />} />
      <Route path="/generate-qr" element={<QRGenerator />} />
    </Routes>
  );
}

export default App;
